import { httpClient } from "./common";
import { ResponseData } from "./types";
import { withApiErrorHandling } from "./withApiErrorHandling";

export class CategoriesAPI {
  public static readonly BASE_URL = "/categories";

  static async getCategories(): Promise<
    ResponseData<{
      id: number;
      name: string;
    }>
  > {
    return withApiErrorHandling(
      () => httpClient.get(`${CategoriesAPI.BASE_URL}`, true),
      "Error al obtener las categorías"
    );
  }
}
